// hooks/useFetchTransactions.ts
import { useState, useEffect } from "react";
import axios from "axios";
import { TransactionResponse } from "../../const/transaction";
//import { Profiles, ProfilesResponse } from "../../const/profiles";

const apiUrl = process.env.REACT_APP_API_URL;

const useFetchErrorLogs = (
  token: any,
  _page: number,
  _pageSize: number,
  filter: any
) => {
  const [logs, setLogs] = useState<any[] | any>([]);
  
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);


  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.post<any>(
          `${apiUrl}/api/v1/admin/errors/all`, 
          {
            filters: filter,
            pagination: {
              page: _page,
              pageSize: _pageSize,
            }
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setLogs(response?.data?.response);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [token, _page, _pageSize, filter]);

  return { logs, loading, error };
};

export default useFetchErrorLogs;
